import React from "react";
import AsyncSelect from "react-select/async/dist/react-select.esm";
import moment from "moment";

export default class InvoicePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        }
        this.searchInvoices = this.searchInvoices.bind(this)
        this.onChangeInvoice = this.onChangeInvoice.bind(this)
    }

    onChangeInvoice(e) {
        this.props.onChangeInvoice(e ? (this.isMulti() ? e : [e]) : []);
    }

    isMulti() {
        return Boolean(this.props.isMulti);
    }

    searchInvoices(query) {
        if (!query) return Promise.resolve([]);

        return new Promise((resolve, reject) => {
            this.setState({isLoading: true});
            
            // Limpiamos espacios para que la búsqueda sea fluida
            const cleanQuery = query.trim().replace(/\s/g, '');

            fetch(`/api/notascd/listrv/1/?search=${cleanQuery}`)
                .then(r => r.json())
                .then(ventas => {
                    const mappedVentas = ventas.map(v => {
                        const formatoFechaHora = moment(v.FechaEmision).format("DD/MM/YYYY hh:mm A");

                        return {
                            ...v,
                            label: `${v.Serie}-${v.NumeroComprobante}  ( ${formatoFechaHora} )`,
                            value: v.IdRegistroVenta
                        }
                    });
                    resolve(mappedVentas);
                })
                .catch(reject)
                .finally(() => this.setState({isLoading: false}));
        });
    }
    render() {
        return (
            <AsyncSelect
                isDisabled={Boolean(this.props.readOnly)}
                cacheOptions
                defaultOptions={true}
                onChange={this.onChangeInvoice}
                isClearable={true}
                isLoading={this.state.isLoading}
                loadOptions={this.searchInvoices}
                isMulti={this.isMulti()}
                placeholder={this.props.placeholder || "Buscar por serie o número (ej: FE02-253 o 253)"}
                loadingMessage={() => "Buscando comprobantes..."}
                noOptionsMessage={() => "No se encontraron resultados"}
            />
        );
    }
}